import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * /grades — top of the content hierarchy. Row click navigates to
 * /grades/:gradeId. Create/edit still modal (small form). Drag-to-reorder
 * remains via SortableTable.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { deleteGrade, listGrades, reorderGrades, } from '../../api';
import { PageHeader } from '../../components/PageHeader';
import { notifySuccess } from '../../components/errors';
import { useLoader } from '../../components/useLoader';
import { SortableTable } from '../../components/SortableTable';
import { actionsCol, emptyState, navRowProps } from '../../components/tableHelpers';
import { GradeModal } from '../../components/content/GradeModal';
export default function GradesListScreen() {
    const nav = useNavigate();
    const { data, loading, reload } = useLoader(listGrades, []);
    const [creating, setCreating] = useState(false);
    const [editing, setEditing] = useState(null);
    const del = async (g) => {
        try {
            await deleteGrade(g.id);
            notifySuccess('הכיתה נמחקה');
            reload();
        }
        catch { /* client auto-surfaces */ }
    };
    const cols = [
        { title: 'שם', dataIndex: 'name' },
        { title: 'מחיר (₪)', dataIndex: 'price', width: 110 },
        actionsCol((g) => setEditing(g), del),
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "\u05DB\u05D9\u05EA\u05D5\u05EA", breadcrumb: [{ label: 'ניהול' }, 'כיתות'], actions: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => setCreating(true), children: "\u05DB\u05D9\u05EA\u05D4 \u05D7\u05D3\u05E9\u05D4" }) }), _jsx(Card, { children: (!loading && (data?.length ?? 0) === 0)
                    ? emptyState('אין עדיין כיתות — צור את הראשונה', { label: 'כיתה חדשה', onClick: () => setCreating(true) })
                    : (_jsx(SortableTable, { size: "small", loading: loading, dataSource: data ?? [], columns: cols, onRow: navRowProps((g) => nav(`/grades/${g.id}`)), onReorder: async (ids) => { await reorderGrades(ids); reload(); } })) }), _jsx(GradeModal, { open: creating, onClose: () => setCreating(false), onDone: () => { setCreating(false); reload(); } }), editing && (_jsx(GradeModal, { open: true, onClose: () => setEditing(null), onDone: () => { setEditing(null); reload(); }, initial: editing }))] }));
}
